import {
  UserSubscriptionTypes,
  UserSubscriptionTypesFormatted,
} from '../enums/UserSubscriptionTypes';

const subscriptionsTypes: Record<string, UserSubscriptionTypes> = {
  gratuita: UserSubscriptionTypes.free,
  standard: UserSubscriptionTypes.standard,
  premium: UserSubscriptionTypes.premium,
  vip: UserSubscriptionTypes.vip,
  admin: UserSubscriptionTypes.admin,
  platinum: UserSubscriptionTypes.platinum,
};

export function getUserSubscriptionType(value: string): UserSubscriptionTypes {
  const toCheck = (value as string)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const subscription = subscriptionsTypes[toCheck];
  return subscription;
}

export function getUserSubscriptionTypeFormatted(
  value: string
): UserSubscriptionTypesFormatted | undefined {
  const type = getUserSubscriptionType(value ?? '');

  if (!type) return undefined;

  return UserSubscriptionTypesFormatted[type];
}
